export default "__VITE_ASSET__CIy$REGi__"